module.exports = __webpack_public_path__ + "img/logo.08f98aa3.png";